export default {
  clientSearches: '/properties/client-searches',
};
